import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { TableCellProps } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ReactElement } from 'react';
import { currencyFormatterNoDecimals } from './edit-pdf/common/currency-formatter';
import { formatPercentage } from './edit-pdf/common/percentage-formatter';

const headerCellProps = {
  align: 'center',
  sx: {
    color: 'white',
    fontSize: '24px',
  },
} as TableCellProps;

const bodyCellProps = {
  align: 'center',
  sx: {
    fontSize: '24px',
  },
} as TableCellProps;

const DenseTable = ({ proposalData }: { proposalData: any }) => {
  const { loan } = proposalData || {};
  const {
    grossIncome,
    expenses,
    loan: loanCashFlow,
  } = proposalData?.cashFlow?.elements || {};
  const { capexCosts } = proposalData?.project || {};
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 750 }} size="small">
        <TableHead
          sx={{
            backgroundColor: '#002060',
            color: 'white',
          }}
        >
          <TableRow
            sx={{
              '& td, & th': {
                border: 0,
                borderRight: '1px solid rgba(224, 224, 224, 1)',
              },
            }}
          >
            <TableCell {...headerCellProps}>Ano</TableCell>
            <TableCell {...headerCellProps} colSpan={3}>
              Investimento
            </TableCell>
            <TableCell {...headerCellProps}></TableCell>
            <TableCell {...headerCellProps} colSpan={2}>
              Despesas Estimadas
            </TableCell>
            <TableCell {...headerCellProps}></TableCell>
            <TableCell {...headerCellProps}></TableCell>
            <TableCell {...headerCellProps}></TableCell>
          </TableRow>
          <TableRow
            sx={{
              '& td, & th': {
                borderRight: '1px solid rgba(224, 224, 224, 1)',
              },
            }}
          >
            <TableCell {...headerCellProps}></TableCell>
            <TableCell {...headerCellProps}>
              Financiamento Entrada{' '}
              {`(${formatPercentage(loan?.downPaymentPercentage)})`}
            </TableCell>
            <TableCell {...headerCellProps}>
              Valor Financiado{' '}
              {`(${formatPercentage(1 - loan?.downPaymentPercentage)})`}
            </TableCell>
            <TableCell {...headerCellProps}>Total (100%)</TableCell>
            <TableCell {...headerCellProps}>Economia Bruta</TableCell>
            <TableCell {...headerCellProps}>Gestão</TableCell>
            <TableCell {...headerCellProps}>Outras</TableCell>
            <TableCell {...headerCellProps}>Economia Estimada Líq.</TableCell>
            <TableCell {...headerCellProps}>
              Financiamento Estimado{' '}
              {`(${formatPercentage(loan?.annualInterestRate)} a.a.)`}
            </TableCell>
            <TableCell {...headerCellProps}>Resultado</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            sx={{
              '&:last-child td, &:last-child th': { border: 0 },
            }}
          >
            <TableCell {...bodyCellProps}>{0}</TableCell>
            <TableCell {...bodyCellProps}>
              {currencyFormatterNoDecimals.format(
                capexCosts?.total * loan?.downPaymentPercentage,
              )}
            </TableCell>
            <TableCell {...bodyCellProps}>
              {currencyFormatterNoDecimals.format(
                capexCosts?.total * (1 - loan?.downPaymentPercentage),
              )}
            </TableCell>
            <TableCell {...bodyCellProps}>
              {currencyFormatterNoDecimals.format(capexCosts?.total)}
            </TableCell>
            <TableCell {...bodyCellProps}></TableCell>
            <TableCell {...bodyCellProps}></TableCell>
            <TableCell {...bodyCellProps}></TableCell>
            <TableCell {...bodyCellProps}></TableCell>
            <TableCell {...bodyCellProps}></TableCell>
            <TableCell {...bodyCellProps}></TableCell>
          </TableRow>
          {new Array(15).fill(0).map((_, i) => {
            const index = i + 1;
            const result =
              grossIncome[index] - expenses.total[index] - loanCashFlow[index];
            return (
              <TableRow
                key={`${index}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell {...bodyCellProps}>{index}</TableCell>
                <TableCell {...bodyCellProps}></TableCell>
                <TableCell {...bodyCellProps}></TableCell>
                <TableCell {...bodyCellProps}></TableCell>
                <TableCell {...bodyCellProps}>
                  {currencyFormatterNoDecimals.format(grossIncome[index])}
                </TableCell>
                <TableCell
                  {...bodyCellProps}
                  sx={{
                    ...bodyCellProps.sx,
                    minWidth: '200px',
                  }}
                >
                  -
                  {currencyFormatterNoDecimals.format(
                    expenses.management[index],
                  )}
                </TableCell>
                <TableCell
                  {...bodyCellProps}
                  sx={{
                    ...bodyCellProps.sx,
                    minWidth: '200px',
                  }}
                >
                  -
                  {currencyFormatterNoDecimals.format(
                    expenses.total[index] - expenses.management[index],
                  )}
                </TableCell>
                <TableCell {...bodyCellProps}>
                  {currencyFormatterNoDecimals.format(
                    grossIncome[index] - expenses.total[index],
                  )}
                </TableCell>
                <TableCell {...bodyCellProps}>
                  {currencyFormatterNoDecimals.format(loanCashFlow[index])}
                </TableCell>
                <TableCell
                  {...bodyCellProps}
                  sx={{
                    ...bodyCellProps.sx,
                    backgroundColor: result < 0 ? '#FF3E3E' : '#70AD47',
                    border: 0,
                    minWidth: '200px',
                  }}
                >
                  {currencyFormatterNoDecimals.format(result)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export const FinancialFlowSummaryTable = ({
  innerRef,
  proposalData,
}: {
  proposalData: any;
  innerRef: any;
}): ReactElement => {
  if (!proposalData) return <div></div>;
  return (
    <div ref={innerRef}>
      <DenseTable proposalData={proposalData}></DenseTable>
    </div>
  );
};
